export enum ExerciseModuleType {
    TEST = 'TEST',
    AUDIO = 'AUDIO',
    EXAMPLE = 'EXAMPLE',
}